<aside class="bloqueFinanciacion" *ngIf="elementos && elementos?.length>0">
    <div class="container">
        <div class="row">
            <ng-container *ngFor="let elemento of elementos">
                <div class="col-lg-3 col-md-4 col-sm-6">
                    <div>
                        <ng-container *ngIf="elemento?.tit">
                            <b>{{elemento?.tit}}</b>
                            <br />
                        </ng-container>
                        {{elemento?.txt}}
                    </div>
                    <ng-container *ngIf="elemento?.img">
                        <img class="img-responsive center-block" src="{{elemento?.img?.ruta}}"
                            alt="{{elemento?.img?.alt}}" />
                    </ng-container>
                </div>
            </ng-container>
        </div>
    </div>
</aside>